/**
 * A failed service request worth reporting for stability monitoring. `kind`
 * distinguishes a request timeout, a network-level failure, and a server-side
 * error (5xx / 429) — client errors (4xx) are not reported. See PX-3333.
 */
type RequestFailure = {
  kind: 'network' | 'server' | 'timeout'
  status?: number
  url: string
}

type Reporter = (failure: RequestFailure) => void

/**
 * Dependency-injected so that the low-level HTTP client (a `utils` leaf) can
 * report failures without importing the trackers (`config`/`startup`), which
 * would create an import cycle. `startup` registers the real reporter.
 */
let reporter: Reporter = () => undefined

const setRequestFailureReporter = (nextReporter: Reporter): void => {
  reporter = nextReporter
}

const reportRequestFailure = (failure: RequestFailure): void => {
  try {
    reporter(failure)
  } catch {
    // Observability must never break the request path it is observing.
  }
}

export type { RequestFailure }
export { reportRequestFailure, setRequestFailureReporter }
